/**
 * Created by yihong on 1/16/18.
 */

import {stringify} from 'query-string'
import axios from 'axios'

const instant = axios.create();

export function getJSON(url, params = {}, timeout = 10000) {
  return instant.get(url, {
    params: params,
    timeout: timeout
  }).then(resp => {
    return resp.data
  }).catch(e => {
    if (e.message.includes('timeout')) {
      console.log("请求超时", url, params)
    } else if (e.message.includes('Request failed with status code')) {
      const _m = /Request failed with status code (\d+)/.exec(e.message)
      if (_m.length > 0) {
        console.log("状态码错误:" + _m[1], url, params)
      }
    } else {
      console.log("http请求错误", url, params,e.message)
    }
    return null;
  })
}


export function postJSON(url, params, data, timeout = 10000) {
  let target_url = url;
  if (params) {
    if (url.includes('?')) {
      target_url = target_url + "&" + stringify(params)
    } else {
      target_url = target_url + "?" + stringify(params)
    }
  }
  return instant.post(target_url, data).then(resp => {
    return resp.data
  }).catch(e => {
    if (e.message.includes('timeout')) {
      console.log("请求超时", url, params)

    } else if (e.message.includes('Request failed with status code')) {
      const _m = /Request failed with status code (\d+)/.exec(e.message)
      if (_m.length > 0) {
        console.log("状态码错误:" + _m[1], url, params)
      }
    } else {
      console.log("http请求错误", url, params)
    }
    return null;
  })
}

import fetchJsonp from 'fetch-jsonp'

export function getJSONP(url, params = {}, timeout=10000) {

  let target_url = url;
  if (params) {
    if (url.includes('?')) {
      target_url = target_url + "&" + stringify(params)
    } else {
      target_url = target_url + "?" + stringify(params)
    }
  }
  return fetchJsonp(target_url, {
    timeout:timeout
  }).then(res => {
    return res.json();
  }).catch(e => {
    console.error(e);
    if (e.message.includes('timed out')) {
      console.error("请求超时", url, params)

    }  else {
      console.error("http请求错误", url, params)
    }
    return null;
  })
}



// WEBPACK FOOTER //
// ./src/api/myaxios.js